import { render } from "./TextoGrande.vue?vue&type=template&id=51889e03"
import script from "./TextoGrande.vue?vue&type=script&lang=js"
export * from "./TextoGrande.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__